// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"KYfcZKtF_0hejhUmG5iO","body":"DlAqeyNHRDbh2zmQgk3b"};